module.exports = "https://portperrypedals.ca/_res/img/focus-oct.635f524.jpg";